/**
 * Company Size Queue Strategy - handles company size discovery with queue-driven approach
 * Similar to business model strategy but for company sizes (Recent/Current/Past Company Size)
 */

import { generateCompanySizeData } from './companySize/queueUtils';
import { StrategyPhase } from './baseStrategy';

/**
 * Company Size queue strategy function
 * @param {Object} decision - Current decision object
 * @param {Array} messages - Current conversation messages
 * @param {Object} queries - Queries object
 * @returns {Object} Updated decision object
 */
const companySizeQueueStrategy = async (decision, messages, queries = {}) => {
  console.log('📏 COMPANY SIZE QUEUE STRATEGY - Processing company size topic');
  
  try {
    // Generate company size data and populate central queue with 3 items:
    // 1. Recent Company Size distribution bar chart
    // 2. Current Company Size distribution bar chart  
    // 3. Past Company Size distribution bar chart
    await generateCompanySizeData(messages, null, decision, true);
    
    console.log('📏 COMPANY SIZE QUEUE STRATEGY: Successfully populated central queue');
    
    return {
      ...decision,
      actionType: 'CONTINUE_DISCOVERY',
      strategyPhase: StrategyPhase.CONVERSATION
    };
    
  } catch (error) {
    console.error('📏 COMPANY SIZE QUEUE STRATEGY: Error:', error);
    
    // Fall back to normal conversation
    return {
      ...decision,
      actionType: 'SEND_TO_BACKEND',
      agentGuidance: 'Let\'s discuss the company size preferences for this role. What size companies are you interested in?',
      strategyPhase: StrategyPhase.CONVERSATION
    };
  }
};

export default companySizeQueueStrategy;